import { render, staticRenderFns } from "./ShowMoreWorkingPlaceContent.vue?vue&type=template&id=210f1e15&scoped=true&lang=pug&"
import script from "./ShowMoreWorkingPlaceContent.vue?vue&type=script&lang=ts&"
export * from "./ShowMoreWorkingPlaceContent.vue?vue&type=script&lang=ts&"
import style0 from "./ShowMoreWorkingPlaceContent.vue?vue&type=style&index=0&id=210f1e15&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210f1e15",
  null
  
)

export default component.exports